const susbcriptionStatus = {
  trialing: 'trialing',
  active: 'active',
  canceled: 'canceled'
};

export default susbcriptionStatus;



// WEBPACK FOOTER //
// ./src/constants/subscription-status.js